import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock, ArrowLeft } from 'lucide-react';
import { blogPosts } from '../data/blogPosts';
import { Seo } from './Seo';

const BlogPage = () => (
  <div className="min-h-screen bg-alabaster-100" data-testid="blog-page">
    <Seo
      title="Massage Tips & Wellness Blog | Dublin Holistic Massage"
      description="Expert advice from Dublin massage therapists: deep tissue benefits, sports recovery, couples massage ideas, Lomi Lomi and more."
    />
    <div className="max-w-6xl mx-auto px-6 sm:px-8 py-16 sm:py-24">
      <Link to="/" className="inline-flex items-center gap-2 text-sage-600 hover:text-luxury-green text-sm mb-10 transition-colors" data-testid="blog-back-home">
        <ArrowLeft size={16} />
        Back to home
      </Link>
      <span className="block text-luxury-gold-700 text-xs uppercase tracking-[0.3em] font-semibold mb-4">Wellness Blog</span>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-luxury-green-900 mb-4">
        Massage Tips <span className="italic text-luxury-gold-700">& Advice</span>
      </h1>
      <p className="text-stone-500 font-light max-w-xl mb-14">
        Honest, practical guidance from our therapists — over 14 years of hands-on experience in Dublin.
      </p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {blogPosts.map((post) => (
          <Link
            key={post.slug}
            to={`/blog/${post.slug}`}
            className="group bg-white rounded-3xl overflow-hidden border border-stone-200 hover:border-luxury-gold/60 hover:-translate-y-1 transition-[transform,border-color] duration-300 shadow-sm"
            data-testid={`blog-card-${post.slug}`}
          >
            <div className="h-48 overflow-hidden">
              <img src={post.image} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="p-6">
              <div className="flex items-center gap-2 text-stone-400 text-xs mb-3">
                <Clock size={12} />
                {post.readTime}
              </div>
              <h2 className="font-display text-xl text-luxury-green-900 mb-2 leading-snug">{post.title}</h2>
              <p className="text-stone-500 text-sm font-light leading-relaxed mb-4">{post.excerpt}</p>
              <span className="inline-flex items-center gap-1.5 text-luxury-gold-700 text-xs uppercase tracking-wider font-semibold">
                Read article
                <ArrowRight size={13} className="group-hover:translate-x-1 transition-transform" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  </div>
);

export default BlogPage;
